module.exports = __webpack_public_path__ + "home-block-3-overlay-wide-CrcVWr1.png";